import { useAuthStore } from '../auth/useAuthStore'
import { authedJSON } from './http'

export interface AppOrdersResponse {
  upstreamOrderIds: string[]
  symbols: string[]
  /**
   * Pairs upstream broker order ids to their fleet trade `group_key`
   * (= parent_intent_id ?? order_events.id). Lets the UI link any
   * app-placed order back to its trade detail page at /trades/:tradeId.
   * May be missing on older server builds; treat as optional.
   */
  orderGroups?: Array<{ upstreamOrderId: string; groupKey: string }>
}

export async function getAppOrders(): Promise<AppOrdersResponse> {
  const accountId = useAuthStore.getState().accountId
  if (!accountId) throw new Error('No active account')
  return getAppOrdersForAccount(accountId)
}

export async function getAppOrdersForAccount(accountId: string): Promise<AppOrdersResponse> {
  return authedJSON<AppOrdersResponse>(
    `/api/accounts/${encodeURIComponent(accountId)}/app-orders`,
  )
}
